<div class="w-full flex flex-col relative">
  <div
    class="absolute px-4 py-2 flex gap-2 items-center top-2 left-2 leaves-metric rounded-lg z-1"
    data-testid="leaves-metric"
  >
    <div class="text-[1.375rem]/[160%] text-[#003555] font-bold">{{ currentUserLeaves() }}</div>
    <div class="text-[1.125rem]/[160%] text-[#0072B9]">{{ 'my-forest.leaves' | translate }}</div>
    <i
      nz-tooltip
      appHideTooltipOnScroll
      [nzTooltipTitle]="'my-forest.leavesTooltip' | translate"
      nzTooltipPlacement="right"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M12.0016 2C17.5253 2 22.0031 6.47784 22.0031 12.0016C22.0031 17.5253 17.5253 22.003 12.0016 22.003C6.47784 22.003 2 17.5253 2 12.0016C2 6.47784 6.47784 2 12.0016 2ZM12.0016 3.5C7.30627 3.5 3.5 7.30627 3.5 12.0016C3.5 16.6969 7.30627 20.503 12.0016 20.503C16.6969 20.503 20.5031 16.6969 20.5031 12.0016C20.5031 7.30627 16.6969 3.5 12.0016 3.5ZM11.9979 10.5006C12.3776 10.5003 12.6916 10.7823 12.7415 11.1484L12.7484 11.2501L12.752 16.7517C12.7523 17.1659 12.4167 17.502 12.0025 17.5022C11.6228 17.5025 11.3088 17.2205 11.2589 16.8545L11.252 16.7527L11.2484 11.251C11.2482 10.8369 11.5837 10.5009 11.9979 10.5006ZM12.002 7.00281C12.5536 7.00281 13.0007 7.44993 13.0007 8.00148C13.0007 8.55302 12.5536 9.00014 12.002 9.00014C11.4505 9.00014 11.0034 8.55302 11.0034 8.00148C11.0034 7.44993 11.4505 7.00281 12.002 7.00281Z"
          fill="#007DCB"
        />
      </svg>
    </i>
  </div>
  <div class="w-full relative overflow-hidden rounded-t-lg h-[15rem]">
    <img [src]="currentImage()" class="w-full h-full object-cover object-center" />
    <div class="absolute flex flex-col gap-6 bottom-6 right-6 z-1">
      <button
        type="button"
        class="share-ganas-action flex items-center justify-center rounded-full border-0 p-0 transition size-12 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#FCFCFC]"
        data-testid="share-ganas-action"
        nz-tooltip
        appHideTooltipOnScroll
        [attr.aria-label]="'my-forest.shareGanas' | translate"
        [nzTooltipTitle]="'my-forest.shareGanasTooltip' | translate"
        nzTooltipPlacement="top"
        nzTooltipArrowPointAtCenter
        (click)="onShareGanas()"
      >
        <img src="assets/img/my-forest/share-ganas.svg" class="w-8 h-auto" alt="" />
      </button>
      <button
        type="button"
        class="flex items-center justify-center rounded-full border-0 p-0 bg-[#007DCB] hover:bg-[#005990] transition size-12 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#FCFCFC]"
        data-testid="add-referral-action"
        nz-tooltip
        appHideTooltipOnScroll
        [attr.aria-label]="'my-forest.addNewReferral' | translate"
        [nzTooltipTitle]="'my-forest.addNewReferral' | translate"
        nzTooltipPlacement="top"
        (click)="onAddNewReferral()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path
            d="M15.9952 4C16.516 4 16.9465 4.38677 17.0147 4.88883L17.0241 5.02841L17.0258 14.9719H26.9733C27.5413 14.9719 28.0019 15.4324 28.0019 16.0005C28.0019 16.5212 27.6149 16.9516 27.1129 17.0198L26.9733 17.0291H17.0258L17.0285 26.9711C17.0286 27.5392 16.5682 28 16.0002 28C15.4794 28 15.0489 27.6132 14.9807 27.1111L14.9713 26.9715L14.9685 17.0291H5.02666C4.45856 17.0291 3.99805 16.5685 3.99805 16.0005C3.99805 15.4797 4.38501 15.0494 4.88708 14.9812L5.02666 14.9719H14.9685L14.9669 5.02882C14.9668 4.46074 15.4272 4 15.9952 4Z"
            fill="#FCFCFC"
          />
        </svg>
      </button>
    </div>
  </div>
  <div class="level-info py-4 px-6 flex flex-col gap-6">
    <div class="flex w-full justify-center md:justify-between">
      <div class="size-12 justify-center items-center hidden md:flex">
        <ng-container [ngTemplateOutlet]="arrow"></ng-container>
      </div>
      <div class="flex flex-col items-center">
        <div class="text-[1rem]/[160%] md:text-[1.375rem] font-bold text-[#222528]">
          {{ currentLevelName() | translate }}
        </div>
        <div
          class="text-[0.8125rem]/[160%] md:text-[0.9375rem] text-[#505760] text-center max-w-[18.75rem] text-nowrap"
        >
          @if (levelMessageKey()) {
            @let messageParams = levelMessageParams();
            {{
              levelMessageKey() | translate: { count: messageParams.count, leaves: messageParams.leavesKey | translate }
            }}
          } @else {
            {{
              'my-forest.yourForestNeeds'
                | translate: { leaves: yourForestNeeds(), leavesLabel: leavesLabel() | translate }
            }}
          }
        </div>
      </div>
      <div class="size-12 justify-center items-center hidden md:flex">
        <ng-container [ngTemplateOutlet]="arrow" [ngTemplateOutletContext]="{ isNext: true }"></ng-container>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <nz-progress
        [nzType]="'line'"
        [nzStrokeWidth]="12"
        [nzPercent]="currentLevelProgress()"
        [nzShowInfo]="false"
        [nzStrokeColor]="'#16AB52'"
        [nzStrokeLinecap]="currentLevelProgress() === 0 ? 'square' : 'round'"
      ></nz-progress>
      <div class="w-full flex gap-4 items-center">
        <div class="text-[0.9375rem]/[160%] md:text-[0.9375rem] !text-[#393E44]">
          {{ needsLeavesToTheCurrentLevel() }}
        </div>
        <div class="flex-1 flex text-[0.8125rem]/[160%] md:text-[0.9375rem] !text-[#737980] justify-center">
          {{ 'my-forest.leaves' | translate }}
        </div>
        <div class="text-[0.9375rem]/[160%] md:text-[0.9375rem]/[160%] !text-[#393E44]">
          {{ needsLeavesToTheNextLevel() }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template let-isNext="isNext" #arrow>
  @if (isNext) {
    <i
      class="rotate-180"
      [class.cursor-pointer]="!nextLevelDisabled()"
      [class.enabled]="!nextLevelDisabled()"
      [class.disabled]="nextLevelDisabled()"
      (click)="onNextLevel()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
          d="M10.7327 4.70698C11.0326 4.42123 11.5074 4.43278 11.7931 4.73276C12.0788 5.03275 12.0672 5.50757 11.7673 5.79331L5.5159 11.749H20.25C20.6642 11.749 21 12.0849 21 12.4992C21 12.9134 20.6642 13.2493 20.25 13.2493H5.5158L11.7673 19.2051C12.0672 19.4909 12.0788 19.9658 11.7931 20.2657C11.5074 20.5657 11.0326 20.5773 10.7327 20.2915L3.3138 13.2235C3.1449 13.0626 3.0449 12.8572 3.0139 12.6439C3.0048 12.5971 3 12.5487 3 12.4992C3 12.4496 3.0048 12.4011 3.014 12.3542C3.045 12.141 3.145 11.9359 3.3138 11.775L10.7327 4.70698Z"
        />
      </svg>
    </i>
  } @else {
    <i
      [class.cursor-pointer]="!prevLevelDisabled()"
      [class.enabled]="!prevLevelDisabled()"
      [class.disabled]="prevLevelDisabled()"
      (click)="onPrevLevel()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
          d="M10.7327 4.70698C11.0326 4.42123 11.5074 4.43278 11.7931 4.73276C12.0788 5.03275 12.0672 5.50757 11.7673 5.79331L5.5159 11.749H20.25C20.6642 11.749 21 12.0849 21 12.4992C21 12.9134 20.6642 13.2493 20.25 13.2493H5.5158L11.7673 19.2051C12.0672 19.4909 12.0788 19.9658 11.7931 20.2657C11.5074 20.5657 11.0326 20.5773 10.7327 20.2915L3.3138 13.2235C3.1449 13.0626 3.0449 12.8572 3.0139 12.6439C3.0048 12.5971 3 12.5487 3 12.4992C3 12.4496 3.0048 12.4011 3.014 12.3542C3.045 12.141 3.145 11.9359 3.3138 11.775L10.7327 4.70698Z"
        />
      </svg>
    </i>
  }
</ng-template>
